export const replaceUnderscores = (status) => {
  return status.replace(/_/g, " ");
};
